export default __webpack_public_path__ + "ui/assets/img/promo-20.svg";